import { render } from "./GoalArchiveActivity.vue?vue&type=template&id=317c4a29"
import script from "./GoalArchiveActivity.vue?vue&type=script&lang=js"
export * from "./GoalArchiveActivity.vue?vue&type=script&lang=js"
script.render = render

export default script